import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import RichTextEditor from "react-rte";
import {styled} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import {useSetRecoilState} from 'recoil';
import {alertState} from '../../../../../recoil-store/recoil-state';

const Input = styled('input')({
    display: 'none',
});

const StepSix = (props) => {
    const {t} = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    const [fileName, setFileName] = useState(props.publishDetail.publish_detail["images"]);
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["guide"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["guide"].toString("html"), "html") :
        RichTextEditor.createEmptyValue())
    const handleEdit = value => {
        setEditorState(value)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                guide: editorState
            }
        }))
    }

    useEffect(() => {
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                images: fileName,

            }
        }))
    }, [fileName])

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    const handleFileRead = async (event) => {
        const file = event.target.files[0]
        const base64 = await convertBase64(file)
        if (fileName.length < 8) {
            setFileName(oldArr => [...oldArr, base64])
        } else {
            setAlert(alert => ({...alert, show: true, message: t('CONTENT.PUBLISH.ERROR-IMAGE'), severity: 'error'}))
        }
    }

    useEffect(() => {
        let valHtml = editorState.toString('html').replace(/(<([^>]+)>)/gi, "").trim()
        if (valHtml.length > 0) { // && fileName.length > 0
            props.setIsRequired(false)
        } else {
            props.setIsRequired(true)
        }
    }, [fileName, editorState])

    return (
        <DialogContent style={{padding: "20px 0 0 0"}}>
            <div style={{textAlign: "left"}}>
                <Grid container>
                    <Grid item xs={3}>
                        <span style={{
                            fontSize: 12,
                            color: "#8F94A6",
                            fontWeight: 700
                        }}>{t('CONTENT.PUBLISH.GUIDE')}</span>
                    </Grid>
                    <Grid item xs={12}>
                        <RichTextEditor
                            editorClassName="publish-editor"
                            value={editorState}
                            onChange={value => handleEdit(value)}
                        />
                    </Grid>

                    {/*<Grid item xs={12}*/}
                    {/*      style={{marginTop: "1rem"}}>*/}
                    {/*    <div id="upload-box">*/}
                    {/*        <label htmlFor="contained-button-file">*/}
                    {/*            <Input accept="image/*" id="contained-button-file" multiple type="file"*/}
                    {/*                   onChange={e => handleFileRead(e)}/>*/}
                    {/*            <Button*/}
                    {/*                variant="outlined"*/}
                    {/*                component="span"*/}
                    {/*                style={{*/}
                    {/*                    backgroundColor: "#46474E",*/}
                    {/*                    borderRadius: "2px",*/}
                    {/*                    color: "#fff",*/}
                    {/*                    width: "20%",*/}
                    {/*                    border: "none",*/}
                    {/*                    fontWeight: 700*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                {t("CONTENT.PUBLISH.ADD-IMAGE")}*/}
                    {/*            </Button>*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</Grid>*/}
                    {/*<Grid item xs={12}>*/}
                    {/*    <span style={{*/}
                    {/*        fontSize: 12,*/}
                    {/*        color: "#8F94A6",*/}
                    {/*        fontWeight: 700*/}
                    {/*    }}>{t('CONTENT.PUBLISH.ADDED-IMAGE')}</span>*/}
                    {/*</Grid>*/}
                    {/*{fileName && fileName.map((item, index) =>*/}
                    {/*    <Grid key={index} item xs={3}>*/}
                    {/*        <ImageThumb index={index} file={item} setFileName={setFileName}/>*/}
                    {/*    </Grid>*/}
                    {/*)}*/}
                </Grid>
            </div>
        </DialogContent>

    );
};
const ImageThumb = ({index, setFileName, file}) => {
    const deleteImg = (id) => {
        setFileName(oldArr => oldArr.filter((item, indx) => indx !== Number(id)))
    }

    return <div><span className="publish-clear-icon" id={index}
                      onClick={(e) => deleteImg(e.target.id)}><DeleteIcon/></span><img
        width="150px"
        height="150px"
        className="publish-clear-image"
        src={file}
        alt="publish-icon"/></div>;
};
export default StepSix;
